//grid:
export const OPEN_DIALOG = "OPEN_MODAL";
export const HIDE_DIALOG = "HIDE_MODAL";
export const CHANGE_SECTION = "CHANGE_SECTION";
export const NAVIGATION = "NAVIGATION";
export const SET_SECTIONS = "SET_SECTIONS";

//aux tipo zona:
export const GET_TIPOS_ZONA = "GET_TIPOS_ZONA";
export const UPDATE_TIPOS_ZONA = "UPDATE_TIPOS_ZONA";
export const ADD_TIPO_ZONA = "ADD_TIPO_ZONA";
export const MODIFY_TIPO_ZONA = "MODIFY_TIPO_ZONA";
export const DELETE_TIPO_ZONA = "DELETE_TIPO_ZONA";

//aux grupo partida:
export const GET_GRUPO_PARTIDA = "GET_GRUPO_PARTIDA";
export const UPDATE_GRUPO_PARTIDA = "UPDATE_GRUPO_PARTIDA";
export const ADD_GRUPO_PARTIDA = "ADD_GRUPO_PARTIDA";
export const MODIFY_GRUPO_PARTIDA = "MODIFY_GRUPO_PARTIDA";
export const DELETE_GRUPO_PARTIDA = "DELETE_GRUPO_PARTIDA";

//aux tipo zona iva:
export const GET_TIPO_ZONA_IVA = "GET_TIPO_ZONA_IVA";
export const UPDATE_TIPO_ZONA_IVA = "UPDATE_TIPO_ZONA_IVA";
export const ADD_TIPO_ZONA_IVA = "ADD_TIPO_ZONA_IVA";
export const MODIFY_TIPO_ZONA_IVA = "MODIFY_TIPO_ZONA_IVA";
export const DELETE_TIPO_ZONA_IVA = "DELETE_TIPO_ZONA_IVA";

//aux tipo partida:
export const GET_TIPOS_PARTIDA = "GET_TIPOS_PARTIDA";
export const UPDATE_TIPOS_PARTIDA = "UPDATE_TIPOS_PARTIDA";
export const ADD_TIPO_PARTIDA = "ADD_TIPO_PARTIDA";
export const MODIFY_TIPO_PARTIDA = "MODIFY_TIPO_PARTIDA";
export const DELETE_TIPO_PARTIDA = "DELETE_TIPO_PARTIDA";

//aux tipo maquina:
export const GET_TIPOS_MAQUINA = "GET_TIPOS_MAQUINA";
export const UPDATE_TIPOS_MAQUINA = "UPDATE_TIPOS_MAQUINA";
export const ADD_TIPO_MAQUINA = "ADD_TIPO_MAQUINA";
export const MODIFY_TIPO_MAQUINA = "MODIFY_TIPO_MAQUINA";
export const DELETE_TIPO_MAQUINA = "DELETE_TIPO_MAQUINA";

//aux modelo maquina:
export const GET_MODELOS_MAQUINA = "GET_MODELOS_MAQUINA";
export const MODIFY_MODELO_MAQUINA = "MODIFY_MODELO_MAQUINA";
export const ADD_MODELO_MAQUINA = "ADD_MODELO_MAQUINA";
export const DELETE_MODELO_MAQUINA = "DELETE_MODELO_MAQUINA";
export const UPDATE_MODELOS_MAQUINA = "UPDATE_MODELOS_MAQUINA";

//aux tipo articulo:
export const GET_TIPOS_ARTICULO = "GET_TIPOS_ARTICULO";
export const MODIFY_TIPO_ARTICULO = "MODIFY_TIPO_ARTICULO";
export const ADD_TIPO_ARTICULO = "ADD_TIPO_ARTICULO";
export const DELETE_TIPO_ARTICULO = "DELETE_TIPO_ARTICULO";
export const UPDATE_TIPOS_ARTICULO = "UPDATE_TIPOS_ARTICULO";

//aux tipo gasto:
export const GET_TIPOS_GASTO = "GET_TIPOS_GASTO";
export const ADD_TIPO_GASTO = "ADD_TIPO_GASTO";
export const DELETE_TIPO_GASTO = "DELETE_TIPO_GASTO";
export const UPDATE_TIPOS_GASTO = "UPDATE_TIPOS_GASTO";
export const MODIFY_TIPO_GASTO = "MODIFY_TIPO_GASTO";

//mae empresa:
export const GET_EMPRESAS = "GET_EMPRESAS";
export const CREATE_EMPRESA = "CREATE_EMPRESA";
export const UPDATE_EMPRESA = "UPDATE_EMPRESA";
export const DELETE_EMPRESA = "DELETE_EMPRESA";

//mae zona:
export const GET_ZONA_DETALLE = "GET_ZONA_DETALLE";
export const MODIFY_FIELD_DETALLE_ZONA = "MODIFY_FIELD_DETALLE_ZONA";
export const UPDATE_ZONA_DE_UN_CENTRO = "UPDATE_ZONA_DE_UN_CENTRO";
export const GET_ALL_ARTICULOS = "GET_ALL_ARTICULOS";

export const MODIFY_ZONA_TIPO_PARTIDA = "MODIFY_ZONA_TIPO_PARTIDA";
export const ADD_ZONA_TIPO_PARTIDA = "ADD_ZONA_TIPO_PARTIDA";
export const DELETE_ZONA_TIPO_PARTIDA = "DELETE_ZONA_TIPO_PARTIDA";

export const MODIFY_PRODUCTO_DE_ZONA = "MODIFY_PRODUCTO_DE_ZONA";
export const ADD_PRODUCTO_DE_ZONA = "ADD_PRODUCTO_DE_ZONA";
export const DELETE_PRODUCTO_DE_ZONA = "DELETE_PRODUCTO_DE_ZONA";

export const ADD_PRODUCTO_CAJA_DE_ZONA = "ADD_PRODUCTO_CAJA_DE_ZONA";
export const MODIFY_PRODUCTO_CAJA_DE_ZONA = "MODIFY_PRODUCTO_CAJA_DE_ZONA";
export const DELETE_PRODUCTO_CAJA_DE_ZONA = "DELETE_PRODUCTO_CAJA_DE_ZONA";
    

//mae maquina:
export const GET_MAQUINAS_OF_MAE_MAQUINA = "GET_MAQUINAS_OF_MAE_MAQUINA";
export const GET_MAQUINA_DETALLES = "GET_MAQUINA_DETALLES";
export const MODIFY_FIELD_DETALLE_MAQUINA = "MODIFY_FIELD_DETALLE_MAQUINA";
export const DELETE_MAQUINA = "DELETE_MAQUINA";
export const ADD_NEW_MAQUINA = "ADD_NEW_MAQUINA";
export const UPDATE_DETALLES_MAQUINA = "UPDATE_DETALLES_MAQUINA";
export const UPDATE_DETALLES_NEW_MAQUINA = "UPDATE_DETALLES_NEW_MAQUINA";


export const ADD_CONTADOR_MAQUINA = "ADD_CONTADOR_MAQUINA";
export const MODIFY_CONTADOR_MAQUINA = "MODIFY_CONTADOR_MAQUINA";
export const DELETE_CONTADOR_MAQUINA = "DELETE_CONTADOR_MAQUINA";

export const ADD_INCIDENCIA_MAQUINA = "ADD_INCIDENCIA_MAQUINA";
export const DELETE_INCIDENCIA_MAQUINA = "DELETE_INCIDENCIA_MAQUINA";
export const MODIFY_INCIDENCIA_MAQUINA = "MODIFY_INCIDENCIA_MAQUINA";


export const ADD_LICENCIA_MAQUINA = "ADD_LICENCIA_MAQUINA";
export const DELETE_LICENCIA_MAQUINA = "DELETE_LICENCIA_MAQUINA";
export const MODIFY_LICENCIA_MAQUINA = "MODIFY_LICENCIA_MAQUINA";


export const ADD_ITV_MAQUINA = "ADD_ITV_MAQUINA";
export const DELETE_ITV_MAQUINA = "DELETE_ITV_MAQUINA";
export const MODIFY_ITV_MAQUINA = "MODIFY_ITV_MAQUINA";

export const ADD_CENTRO_MAQUINA = "ADD_CENTRO_MAQUINA";
export const DELETE_CENTRO_MAQUINA = "DELETE_CENTRO_MAQUINA";
export const MODIFY_CENTRO_MAQUINA = "MODIFY_CENTRO_MAQUINA";

//mae centro:
export const GET_CENTROS = "GET_CENTROS";
export const GET_CENTRO = "GET_CENTRO";
export const MODIFY_FIELD_DETALLE_CENTRO = "MODIFY_FIELD_DETALLE_CENTRO";
export const MODIFY_FIELDS_CENTRO_DIALOG = "MODIFY_FIELDS_CENTRO_DIALOG";
export const NOT_SAVED_MORE_DETAILS = "NOT_SAVED_MORE_DETAILS";
export const UPDATE_CENTRO = "UPDATE_CENTRO";
export const CREATE_CENTRO = "CREATE_CENTRO";
export const COPY_CENTRO = "COPY_CENTRO";
export const DELETE_CENTRO = "DELETE_CENTRO";
export const GET_CAJAS_CENTRO =  "GET_CAJAS_CENTRO";
export const GET_ZONAS_CENTRO =  "GET_ZONAS_CENTRO";
export const GET_CONTAB_CENTRO =  "GET_CONTAB_CENTRO";
export const MODIFY_CONTAB_CENTRO = "MODIFY_CONTAB_CENTRO";
export const ADD_CONTAB_CENTRO = "ADD_CONTAB_CENTRO";
export const REMOVE_CONTAB_CENTRO = "REMOVE_CONTAB_CENTRO";
export const MODIFY_CAJA_CENTRO =  "MODIFY_CAJA_CENTRO";
export const ADD_CAJA_CENTRO =  "ADD_CAJA_CENTRO";
export const REMOVE_CAJA_CENTRO =  "REMOVE_CAJA_CENTRO";
export const MODIFY_ZONA_CENTRO =  "MODIFY_ZONA_CENTRO";
export const ADD_ZONA_CENTRO =  "ADD_ZONA_CENTRO";
export const REMOVE_ZONA_CENTRO = "REMOVE_ZONA_CENTRO";
export const GET_TIPOSZONASIVA_CENTRO = "GET_TIPOSZONASIVA_CENTRO";
export const GET_ZONAIVA_CENTRO = "GET_ZONAIVA_CENTRO";
export const MODIFY_ZONAIVA_CENTRO = "MODIFY_ZONAIVA_CENTRO";
export const ADD_ZONAIVA_CENTRO = "ADD_ZONAIVA_CENTRO";
export const REMOVE_ZONAIVA_CENTRO = "REMOVE_ZONAIVA_CENTRO";
export const GET_CENTROS_CENTRO = "GET_CENTROS_CENTRO";
export const ADD_CENTRO_CENTRO = "ADD_CENTRO_CENTRO";
export const REMOVE_CENTRO_CENTRO = "REMOVE_CENTRO_CENTRO";

//cierre diario:
export const GET_CIERRE_DIARIO = "GET_CIERRE_DIARIO";
export const MODIFY_DATOS_CIERRE_DIARIO = "MODIFY_DATOS_CIERRE_DIARIO";
export const UPDATE_DATOS_CIERRE_DIARIO = "UPDATE_DATOS_CIERRE_DIARIO";
export const SET_CENTRO_DIA = "SET_CENTRO_DIA";
export const SET_INITIAL_CENTRO_DIA = "SET_INITIAL_CENTRO_DIA";
export const INVALIDATE_CENTRO_DIA = "INVALIDATE_CENTRO_DIA";
export const ENABLE_CENTRO_DIA = "ENABLE_CENTRO_DIA";
export const GET_ARTGASTOS = "GET_ARTGASTOS";
export const GET_ARTMKT = "GET_ARTMKT";
export const GET_TIPO_GASTOS_CIERRE = "GET_TIPO_GASTOS_CIERRE";
export const GET_OTROS_DATOS_CIERRE_DIARIO = "GET_OTROS_DATOS_CIERRE_DIARIO";
export const MODIFY_FIELD_OTROSDATOS_CIERRE = "MODIFY_FIELD_OTROSDATOS_CIERRE";
export const NEW_OTROSDATOS = "NEW_OTROSDATOS";
export const UPDATE_OTROSDATOS_CIERRE = "UPDATE_OTROSDATOS_CIERRE";
export const DESBLOQUEAR_CIERRE_DIARIO = "DESBLOQUEAR_CIERRE_DIARIO";
export const CIERRE_DIARIO_CERRAR_DIA = "CIERRE_DIARIO_CERRAR_DIA";
export const GET_PARTIDAS_POR_TIPO = "GET_PARTIDAS_POR_TIPO";
export const GET_RESUMEN_CIERRE_DIARIO = "GET_RESUMEN_CIERRE_DIARIO";

//mover_maquinas:
export const GET_MAQUINAS_CENTRO_ORIGEN = "GET_MAQUINAS_CENTRO_ORIGEN";
export const GET_MAQUINAS_CENTRO_DESTINO = "GET_MAQUINAS_CENTRO_DESTINO";
export const MOVE_MAQUINA_TO_CENTRO_DESINO = "MOVE_MAQUINA_TO_CENTRO_DESINO";

//cierre semanal
export const GET_CIERRE_SEMANAL_DATOS = "GET_CIERRE_SEMANAL_DATOS";
export const GET_OTROS_DATOS_CIERRE_SEMANAL = "GET_OTROS_DATOS_CIERRE_SEMANAL";
export const MODIFY_FIELD_OTROSDATOS_CIERRE_SEMANAL = "MODIFY_FIELD_OTROSDATOS_CIERRE_SEMANAL";
export const MODIFY_ARQUEO_CIERRE_SEMANAL = "MODIFY_ARQUEO_CIERRE_SEMANAL";
export const MODIFY_BANCO_2_CIERRE_SEMANAL = "MODIFY_BANCO_2_CIERRE_SEMANAL";
export const MODIFY_VARIACION_EUROS = "MODIFY_VARIACION_EUROS";
export const MODIFY_VARIACION_TOKENS = "MODIFY_VARIACION_TOKENS";
export const MODIFY_VARIACION_TOKENS_CENTRO = "MODIFY_VARIACION_TOKENS_CENTRO";
export const UPDATE_DATOS_CIERRE_SEMANAL = "UPDATE_DATOS_CIERRE_SEMANAL";
export const UPDATE_OTROS_DATOS_CIERRE_SEMANAL = "UPDATE_OTROS_DATOS_CIERRE_SEMANAL";
export const DESBLOQUEAR_CIERRE_SEMANAL = "DESBLOQUEAR_CIERRE_SEMANAL";
export const CIERRE_SEMANAL_CERRAR_SEMANA = "CIERRE_SEMANAL_CERRAR_SEMANA";
export const GET_RESUMEN_CIERRE_SEMANAL = "GET_RESUMEN_CIERRE_SEMANAL";
export const MODIFY_MAQ_ARCADE_CIERRE_SEMANAL = "MODIFY_MAQ_ARCADE_CIERRE_SEMANAL";
export const RESET_CIERRE_SEMANAL_DATOS = "RESET_CIERRE_SEMANAL_DATOS";
export const UPDATE_BILLARES_CIERRE_SEMANAL = "UPDATE_BILLARES_CIERRE_SEMANAL";



//presupuestos
export const GET_PRESUPUESTO = "GET_PRESUPUESTO";
export const GET_PRESUPUESTO_DETALLE = "GET_PRESUPUESTO_DETALLE";
export const GET_NEW_PRESUPUESTO_DETALLE = "GET_NEW_PRESUPUESTO_DETALLE";
export const GENERATE_PRESUPUESTO = "GENERATE_PRESUPUESTO";
export const UPDATE_PRESUPUESTO_DETALLE = "UPDATE_PRESUPUESTO_DETALLE";
export const UPDATE_SELECTED_ORIGIN = "UPDATE_SELECTED_ORIGIN";
export const COPIAR_PRESUPUESTO = "COPIAR_PRESUPUESTO";
export const CAMBIAR_BLOQUEO_PRESUPUESTO = "CAMBIAR_BLOQUEO_PRESUPUESTO";

//save_state
export const SET_SAVE_STATE_PENDING = "SET_SAVE_STATE_PENDING";

//user
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const SET_SELECTED_USER_CENTRO_PROFILE = "SET_SELECTED_USER_CENTRO_PROFILE";

//perfiles usuario
export const GET_USUARIOS = "GET_USUARIOS";
export const GET_USUARIOS_KD = "GET_USUARIOS_KD";
export const GET_USUARIO_DETALLES = "GET_USUARIO_DETALLES";
export const MODIFY_USUARIO_DETALLES = "MODIFY_USUARIO_DETALLES";
export const UPDATE_USUARIO_DETALLES = "UPDATE_USUARIO_DETALLES";
export const ADD_NEW_USUARIO = "ADD_NEW_USUARIO";

export const ADD_CENTRO_USUARIO = "ADD_CENTRO_USUARIO";
export const DELETE_CENTRO_USUARIO = "DELETE_CENTRO_USUARIO";
export const MODIFY_CENTRO_USUARIO = "MODIFY_CENTRO_USUARIO";

//aux familia:
export const GET_FAMILIA = "GET_FAMILIA";
export const UPDATE_FAMILIA = "UPDATE_FAMILIA";
export const ADD_FAMILIA = "ADD_FAMILIA";
export const MODIFY_FAMILIA = "MODIFY_FAMILIA";
export const DELETE_FAMILIA = "DELETE_FAMILIA";

//aux familia:
export const GET_MOTIVO = "GET_MOTIVO";
export const UPDATE_MOTIVO = "UPDATE_MOTIVO";
export const ADD_MOTIVO = "ADD_MOTIVO";
export const MODIFY_MOTIVO = "MODIFY_MOTIVO";
export const DELETE_MOTIVO = "DELETE_MOTIVO";


//aux sub familia:
export const GET_SUB_FAMILIA = "GET_SUB_FAMILIA";
export const UPDATE_SUB_FAMILIA = "UPDATE_SUB_FAMILIA";
export const ADD_SUB_FAMILIA = "ADD_SUB_FAMILIA";
export const MODIFY_SUB_FAMILIA = "MODIFY_SUB_FAMILIA";
export const DELETE_SUB_FAMILIA = "DELETE_SUB_FAMILIA";

//aux sub tipo ficha:
export const GET_TIPO_FICHA = "GET_TIPO_FICHA";
export const UPDATE_TIPO_FICHA = "UPDATE_TIPO_FICHA";
export const ADD_TIPO_FICHA = "ADD_TIPO_FICHA";
export const MODIFY_TIPO_FICHA = "MODIFY_TIPO_FICHA";
export const DELETE_TIPO_FICHA = "DELETE_TIPO_FICHA";

//aux sub tipo ficha sub:
export const GET_TIPO_FICHA_SUB = "GET_TIPO_FICHA_SUB";
export const UPDATE_TIPO_FICHA_SUB = "UPDATE_TIPO_FICHA_SUB";
export const ADD_TIPO_FICHA_SUB = "ADD_TIPO_FICHA_SUB";
export const MODIFY_TIPO_FICHA_SUB = "MODIFY_TIPO_FICHA_SUB";
export const DELETE_TIPO_FICHA_SUB = "DELETE_TIPO_FICHA_SUB";

//aux sub tipo mov redem:
export const GET_TIPO_MOV_REDEM = "GET_TIPO_MOV_REDEM";
export const UPDATE_TIPO_MOV_REDEM = "UPDATE_TIPO_MOV_REDEM";
export const ADD_TIPO_MOV_REDEM = "ADD_TIPO_MOV_REDEM";
export const MODIFY_TIPO_MOV_REDEM = "MODIFY_TIPO_MOV_REDEM";
export const DELETE_TIPO_MOV_REDEM = "DELETE_TIPO_MOV_REDEM";

//aux promociones:
export const GET_PROMOCION = "GET_PROMOCION";
export const UPDATE_PROMOCION = "UPDATE_PROMOCION";
export const ADD_PROMOCION = "ADD_PROMOCION";
export const MODIFY_PROMOCION = "MODIFY_PROMOCION";
export const DELETE_PROMOCION = "DELETE_PROMOCION";

//aux promociones:
export const GET_SEGMENTACION = "GET_SEGMENTACION";
export const UPDATE_SEGMENTACION = "UPDATE_SEGMENTACION";
export const ADD_SEGMENTACION = "ADD_SEGMENTACION";
export const MODIFY_SEGMENTACION = "MODIFY_SEGMENTACION";
export const DELETE_SEGMENTACION = "DELETE_SEGMENTACION";

//UTILS
export const LOADING = "LOADING";
